import React from 'react';
import { Calendar, Tag } from 'lucide-react';
import { useSiteContent } from '../context/SiteContentContext';
import { resolveImageUrl } from '../utils/urls';

const Information = () => {
  const { newsItems } = useSiteContent();
  if (!newsItems || newsItems.length === 0) return null;
  const [first, ...rest] = newsItems;
  const grid = [first, ...rest.slice(0, 4)];

  return (
    <section id="news" className="py-16 lg:py-24 bg-white" data-testid="news-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-extrabold text-gray-900">
            <span className="text-[#0a3d8f]">JILONG</span>{' '}
            <span className="text-gray-400 font-light">Information</span>
          </h2>
          <div className="section-divider"></div>
        </div>

        <div className="grid lg:grid-cols-3 gap-5">
          <a
            href={grid[0].link || '#news'}
            target={grid[0].link ? '_blank' : undefined}
            rel="noreferrer"
            data-testid="news-feature"
            className="info-card relative lg:col-span-2 lg:row-span-2 rounded-xl overflow-hidden shadow-md group min-h-[320px]"
          >
            <img src={resolveImageUrl(grid[0].image)} alt={grid[0].title} className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8 text-white">
              <div className="flex items-center gap-3 mb-3 text-sm">
                <span className="inline-flex items-center gap-1 bg-[#e60012] px-2.5 py-1 rounded text-xs font-semibold">
                  <Tag size={12} /> {grid[0].category}
                </span>
                <span className="inline-flex items-center gap-1 text-white/80">
                  <Calendar size={12} /> {grid[0].date}
                </span>
              </div>
              <h3 className="text-xl lg:text-2xl font-bold leading-snug mb-3">{grid[0].title}</h3>
              <span className="inline-flex items-center gap-1 text-sm font-semibold border-b border-white/60 pb-0.5">
                Learn more +
              </span>
            </div>
          </a>

          {grid.slice(1, 5).map((item) => (
            <a
              key={item.id}
              href={item.link || '#news'}
              target={item.link ? '_blank' : undefined}
              rel="noreferrer"
              data-testid={`news-card-${item.id}`}
              className="info-card relative rounded-xl overflow-hidden shadow-md group min-h-[154px]"
            >
              <img src={resolveImageUrl(item.image)} alt={item.title} className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                <div className="text-xs text-white/80 mb-1">{item.date}</div>
                <h4 className="text-sm font-bold leading-snug line-clamp-2">{item.title}</h4>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Information;
